// Shown on the catalog page when the visitor filters down to exactly one
// brand — an "about this brand" blurb, not per-collection copy (each
// SuMisura/Royale product already carries its own collection description,
// see sumisuraSeed.ts). Only populated for brands the user has explicitly
// asked for one; a brand with no entry here just renders no blurb.
//
// Kept deliberately short (one sentence, sometimes two) — these render
// beside the catalog banner's giant heading (CatalogVideoBanner), not
// stacked under it, so anything longer wraps awkwardly. For brands with no
// well-documented public history/origin, the copy stays grounded in what
// they actually sell in this catalog rather than inventing specifics
// (founding dates, certifications, factory locations) that can't be
// verified.
export const BRAND_DESCRIPTIONS: Record<string, string> = {
  Raynaud:
    "Французский фарфор из Лиможа с 1849 года — эталон изысканной сервировки для мишленовских ресторанов и отелей по всему миру.",
  Tognana:
    "Итальянская посуда и фарфор — современный дизайн и практичность для профессиональной сервировки в ресторанах и отелях.",
  "Electrolux Professional":
    "Профессиональное кухонное и холодильное оборудование от одного из мировых лидеров индустрии — полная линейка решений для кухни любого масштаба.",
  "100%Chef":
    "Испанский бренд для современной подачи блюд — посуда и инструменты, созданные вместе с шеф-поварами для авторской кухни.",
  Linkrich:
    "Тепловое, холодильное и механическое оборудование для профессиональной кухни — широкий ассортимент по доступной цене.",
  "Life Concept":
    "Посуда для современной сервировки — практичные коллекции для ресторанов, кафе и кейтеринга.",
  "Mac.Pan":
    "Итальянское оборудование для пекарен и пиццерий — тестомесы, печи и линии для промышленной и ресторанной выпечки.",
  Pintinox:
    "Итальянские приборы и столовый инвентарь из нержавеющей стали — качество и стиль для профессиональной сервировки.",
  Hatco:
    "Американский бренд теплового оборудования — витрины, тепловые шкафы и станции для сохранения качества готовых блюд.",
  Arcos:
    "Испанские ножи с 1745 года — один из старейших и самых известных производителей профессиональных кухонных ножей в мире.",
  Royale:
    "Коллекции фарфора Sumisura от Royale® — ручная работа, Италия, лиможский каолин премиального качества, который ценится во всём мире за тонкость, прозрачность и проработку каждой детали вручную. Каждое изделие изготавливается на заказ, срок производства обычно составляет 60–90 дней; из-за индивидуального характера изготовления возврат невозможен. Выбор ресторанов и отелей, ценящих подлинное итальянское мастерство.",
  Hoshizaki:
    "Японский лидер в производстве льдогенераторов и холодильного оборудования — надёжность, проверенная десятилетиями.",
  Stylepoint:
    "Дизайнерская посуда для сервировки — оригинальные формы и фактуры для запоминающейся подачи блюд.",
  BETTER:
    "Тепловое оборудование для профессиональной кухни — плиты, жарочные поверхности и техника для интенсивной эксплуатации.",
  Irinox:
    "Итальянский изобретатель шоковой заморозки — оборудование для быстрого охлаждения, которое сохраняет качество и безопасность продуктов.",
  Hisakage:
    "Холодильное оборудование и льдогенераторы для профессиональной кухни — стабильная работа при высоких нагрузках.",
  Gram: "Датское холодильное оборудование — энергоэффективные решения для профессионального хранения продуктов.",
  FINES: "Оборудование для пекарен и кондитерских — печи и техника для выпечки профессионального уровня.",
  Doregrill:
    "Оборудование для линий раздачи и тепловой обработки — решения для кафе, столовых и кейтеринга.",
  Rocam:
    "Оборудование для линий раздачи и подачи блюд — практичные решения для ресторанов и кейтеринга.",
  Rational:
    "Немецкий изобретатель пароконвектомата — оборудование, ставшее отраслевым стандартом для профессиональных кухонь по всему миру.",
  Crystal:
    "Холодильное оборудование для профессиональной кухни — витрины и шкафы для хранения продуктов при нужной температуре.",
  Nilma:
    "Итальянское оборудование для обработки продуктов — овощерезки и техника для подготовки ингредиентов на профессиональной кухне.",
  Dadaux: "Французские мандолины и инвентарь для нарезки — точность и надёжность, которые ценят шеф-повара.",
  "Turbo Air":
    "Холодильное оборудование для профессиональной кухни — широкая линейка витрин, шкафов и столов с охлаждением.",
  Krupps:
    "Бельгийское оборудование для посудомоечных линий — производительность и надёжность для интенсивной эксплуатации.",
  Cuppone: "Итальянские печи для пиццы — оборудование, которое выбирают профессиональные пиццерии по всему миру.",
  Sayl:
    "Оборудование для линий раздачи и охлаждения — модульные решения для современных заведений общественного питания.",
  Gaser: "Механическое оборудование для профессиональной кухни — техника для обработки и подготовки продуктов.",
  LEHEHE:
    "Оборудование для кофеен и барных станций — техника для приготовления напитков на профессиональном уровне.",
  Tecnomac:
    "Итальянское оборудование для охлаждения и выпечки — техника для профессиональных кухонь и пекарен.",
  Velox:
    "Промышленное оборудование и химия для профессиональной кухни — решения для мойки и обработки поверхностей.",
  Firex: "Итальянское оборудование для тепловой обработки — плиты, сковороды и котлы для профессиональной кухни.",
  Baratta: "Итальянское тепловое оборудование — техника для интенсивной работы профессиональной кухни.",
  ILSA: "Итальянская посуда и столовые приборы — качество и стиль для профессиональной сервировки.",
  Sunmix:
    "Механическое оборудование для профессиональной кухни — миксеры и техника для замеса и обработки продуктов.",
  CB: "Оборудование для профессиональной кухни — тепловая обработка, раздача и подготовка продуктов.",
  GEA: "Немецкий производитель промышленного оборудования — технологичные решения для пищевого производства.",
  VALKO: "Оборудование для профессиональной кухни — техника для механической и тепловой обработки продуктов.",
  Status: "Оборудование для профессиональной кухни — техника для подготовки и обработки продуктов.",
  "Matfer Bourgeat":
    "Французский производитель профессионального кухонного инвентаря — инструменты, которым доверяют шеф-повара по всему миру.",
  OZVAN: "Оборудование для тепловой обработки и выпечки — техника для профессиональной кухни и пекарни.",
  "Marana Forni":
    "Итальянские печи для пиццы и выпечки — традиции итальянского хлебопечения в профессиональном оборудовании.",
  "Carlo Migliavacca":
    "Итальянское оборудование для переработки продуктов — техника для мясных и колбасных цехов.",
  Aroma: "Оборудование для кофеен — техника для приготовления кофе и напитков на профессиональном уровне.",
  Ladetina: "Оборудование для кофеен и барных станций — техника для приготовления напитков.",
  "T&Z": "Оборудование для кофеен — техника для профессиональной барной станции.",
  Kenoanda: "Посуда для профессиональной сервировки — практичные коллекции для ресторанов и кафе.",
  Tiger: "Тепловое оборудование для профессиональной кухни.",
  GMP: "Прачечное оборудование для профессионального использования — техника для отелей и предприятий общепита.",
  Berkel:
    "Легендарный бренд слайсеров с 1898 года — культовый маховый слайсер Berkel узнаваем во всём мире.",
  Cehuma: "Промышленное оборудование для пищевого производства.",
  EZCOOK: "Тепловое оборудование для профессиональной кухни.",
  Häussler: "Немецкое оборудование для пекарен — техника для профессиональной выпечки.",
  Santos: "Французский бренд кухонной техники — оборудование для профессионального использования.",
  Wessamat: "Немецкое оборудование для приготовления мороженого и десертов.",
  Kegland: "Оборудование для розлива и хранения напитков — техника для баров и пивоварен.",
  "Schott Zwiesel":
    "Немецкое стекло премиум-класса — бокалы и посуда, которые выбирают лучшие рестораны и бары мира.",
};
